import { CompanyProfileOnboarding } from '@/types/onboarding'

export const checkIsNeedCompleteOnboarding = (
  prop: CompanyProfileOnboarding | null,
) => {
  if (!prop) return false
  const safeBranch = prop.branches || []
  if (
    !prop.size ||
    !prop.categories.length ||
    !safeBranch.length ||
    !prop.name
  ) {
    return true
  }
  return false
}
